import { useEffect, useState } from "react";
import { ShieldAlert, Eye, Pencil, LogOut } from "lucide-react";
import { api } from "@/lib/api";
import { exitImpersonation } from "@/lib/impersonation";

// Persistent banner shown when a Super Admin is inside a customer's dashboard.
export default function ImpersonationBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/impersonation/status").then((r) => { if (r.data.impersonated) setInfo(r.data); }).catch(() => {});
  }, []);

  if (!info) return null;
  const editing = info.edit_mode;

  return (
    <div data-testid="impersonation-banner"
      className={`sticky top-0 z-50 flex items-center gap-3 px-4 py-2.5 text-sm text-white ${editing ? "bg-amber-600" : "bg-slate-900"}`}>
      <ShieldAlert className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-0">
        You are viewing <b>{info.business_name || info.customer_name}</b> as Super Admin
        <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-xs font-semibold">
          {editing ? <><Pencil className="h-3 w-3" /> Edit mode</> : <><Eye className="h-3 w-3" /> Read-only</>}
        </span>
      </span>
      <button data-testid="exit-impersonation-btn" onClick={exitImpersonation}
        className="shrink-0 inline-flex items-center gap-1.5 rounded-lg bg-white/15 hover:bg-white/25 px-3 py-1.5 font-semibold transition-colors">
        <LogOut className="h-3.5 w-3.5" /> Exit Customer View
      </button>
    </div>
  );
}
